module.exports = __webpack_public_path__ + "static/js/emit-wallet-worker.07c116ef.chunk.worker.js"